/**
 * Utilidades para manejo de estados de licitaciones
 */

/**
 * Obtiene el color del círculo según el estado de la licitación
 * @param estado - Código numérico del estado
 * @returns Color hexadecimal para el estado
 */
export const getStatusColor = (estado: number): string => {
  switch (estado) {
    case 3: // SEGUIDA
      return '#4caf50'; // Verde
    case 2: // PENDIENTE
      return '#ff9800'; // Amarillo
    case 4: // DESCARTADA
      return '#f44336'; // Rojo
    default:
      return '#9e9e9e'; // Gris
  }
};

/**
 * Obtiene el color según el estado de Mercado Público
 * @param estado - String con el estado de MP
 * @returns Color hexadecimal para el estado
 */
export const getMPStatusColor = (estado: string): string => {
  const estadoLower = estado.toLowerCase();
  if (estadoLower.includes('publicada')) return '#2E7D32'; // Verde
  if (estadoLower.includes('cerrada')) return '#D32F2F'; // Rojo
  return '#585858'; // Gris por defecto
}; 